import { forwardRef, type Ref, type SVGProps } from "react";
const IconDownloadOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M29 22a1 1 0 0 0-1 1v5H4v-5a1 1 0 0 0-2 0v5.25A1.62 1.62 0 0 0 3.5 30h25a1.62 1.62 0 0 0 1.5-1.75V23a1 1 0 0 0-1-1"
    />
    <path
      fill="currentColor"
      d="M15.29 23.71a1 1 0 0 0 .33.21.94.94 0 0 0 .76 0 1 1 0 0 0 .33-.21l6-6a1 1 0 0 0-1.42-1.42L17 20.59V3a1 1 0 0 0-2 0v17.59l-4.29-4.3a1 1 0 0 0-1.42 1.42z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconDownloadOutlineSVG);
ForwardRef.displayName = "IconDownloadOutline";
export { ForwardRef as IconDownloadOutline };
